<template>
  <div class="page-order-detail">
    <div class="content">
      <div class="header"></div>
      <div class="container">
        <!-- 状态栏 -->
        <div class="order-status">
          <h2 class="status">{{ orderStatus | cargoStatus }}</h2>
          <span class="status-description">
            {{ isUnpayed ? countDown : data.statusText }}
          </span>
        </div>

        <AuditFailTag v-if="showAuditFailRefund" :orderDetail="data" />

        <!-- 订单收货人信息 -->
        <div class="customer-info-express panel" v-if="deliveryType === 'express'">
          <div style="flex: 1">
            <span class="address">{{ receiverInfo.receiverAddress }}</span>
            <span class="patient-info">{{ receiverInfo.receiverName }} {{ receiverInfo.receiverMobile }}</span>
          </div>
          <!-- <van-button
            v-if="canChangeReceiverAddress"
            style="margin-left: 12px"
            color="#d9d9d9"
            class="btn-text-color-59"
            plain
            round
            hairline
            size="small"
            @click="goChangeAddress"
          >
            修改
          </van-button> -->
        </div>
        <div class="customer-info-pickupbyself-nopay panel" v-if="deliveryType === 'pickupbyself-nopay'">
          <div class="name">
            <span class="label">联系人</span>
            <span class="value">{{ receiverInfo.receiverName }}</span>
          </div>
          <div class="mobile">
            <span class="label">预留电话</span>
            <span class="value">{{ receiverInfo.receiverMobile }}</span>
          </div>
        </div>
        <!-- 自提相关信息 -->
        <div class="customer-info-pickupbyself-payed panel" v-if="deliveryType === 'pickupbyself-payed'">
          <span class="shop-name">{{ (subOrder.storeInfo && subOrder.storeInfo.name) || subOrder.providerName }}</span>
          <span class="shop-time">营业时间：{{ openTime }}</span>
          <div class="write-off-code" v-if="orderStatus === orderStatusEnum.waitGetGoods">
            <span class="code">{{ subOrder.pickCode }}</span>
            <span class="tip">线下核销码</span>
          </div>
          <div class="shop-address">
            <div class="label">自提地址</div>
            <div class="address-text">{{ subOrder.storeInfo && subOrder.storeInfo.address }}</div>
            <van-button
              size="mini"
              plain
              hairline
              round
              class="btn-navigate btn-text-color-59"
              @click="navigate"
              color="#d9d9d9"
            >
              导航
            </van-button>
          </div>
          <div class="line">
            <span class="label">自提时间</span>
            <span class="value bold-text">
              {{ subOrder.timeSection }}
            </span>
          </div>
          <div class="line">
            <span class="label">取件人</span>
            <span class="value bold-text">{{ receiverInfo.receiverName }}</span>
          </div>
          <div class="line">
            <span class="label">预留电话</span>
            <span class="value bold-text">{{ receiverInfo.receiverMobile }}</span>
          </div>
        </div>

        <!-- 订单供应商、商品信息 -->
        <div class="provider-list">
          <div class="provider-item panel" v-for="(provider, index)  in data.providerOrderList" :key="provider.orderId">
            <div class="provider-header">
              <div class="first-line">
                <div class="provider-info van-ellipsis">
                  <img
                    class="provider-logo"
                    :src="
                      provider.deliveryWay == deliverTypeEnum.PICKUPSELF
                        ? (provider.storeInfo && provider.storeInfo.mainImage) || require('@/assets/imgs/zyjk-logo.png')
                        : require('@/assets/imgs/zyjk-logo.png')
                    "
                  />
                  <div class="provider-name van-ellipsis">
                    {{
                      provider.deliveryWay == deliverTypeEnum.PICKUPSELF
                        ? (provider.storeInfo && provider.storeInfo.name) ||
                          provider.providerName ||
                          provider.supplierName
                        : '智云合作供应商'
                    }}
                  </div>
                  <tag v-if="data.providerOrderList.length > 1">拆单</tag>
                  <tag v-if="provider.deliveryWay == deliverTypeEnum.PICKUPSELF">自提</tag>
                  <tag v-if="provider.deliveryWay == deliverTypeEnum.EXPRESS">快递</tag>
                </div>

                <div class="provider-tip">
                  <span
                    v-if="provider.deliveryWay == deliverTypeEnum.PICKUPSELF && provider.storeInfo"
                    class="provider-distance"
                  >
                    {{ distanceMap[provider.storeInfo.supplierId] | distance }}
                  </span>
                </div>
              </div>
              <div class="second-line" v-if="provider.deliveryWay == deliverTypeEnum.PICKUPSELF">
                {{ provider.storeInfo && provider.storeInfo.address }}
              </div>
            </div>
            <div class="separator"></div>

            <div class="hint" v-if="provider.orderClassifyType == '1' && !provider.isShowBuyCount">
              该中药处方为保密方，支付后可见每味药材的开具数量，敬请谅解。
            </div>

            <!-- 商品列表 -->
            <goods-item
              v-for="item in provider.orderDetails"
              :goods="item"
              :key="item.itemId"
              :showGoodsRefundStatus="true"
              @goToRefundDetail="jumpToRefund"
              :showImage="provider.orderClassifyType != '1'"
              :showPrice="provider.orderClassifyType != '1'"
              :showTag="provider.orderClassifyType != '1'"
              :showSpecPrefix="provider.orderClassifyType == '1'"
              :showItemNum="provider.isShowBuyCount"
            />

            <span style="display: block;padding-bottom: 16px" v-if="provider.orderClassifyType == '1'">共{{provider.traditionalMedicineDoseCount || 1}}剂</span>

            <div class="provider-footer" v-else>
              <div class="express">
                <span class="label">
                  {{ provider.deliveryWay == deliverTypeEnum.EXPRESS ? '配送方式' : '自提时间' }}
                </span>
                <span class="value" v-if="provider.deliveryWay == deliverTypeEnum.PICKUPSELF">
                  {{ provider.timeSection }}
                </span>
                <span class="value" v-if="provider.deliveryWay == deliverTypeEnum.EXPRESS">快递配送</span>
              </div>
              <div class="separator"></div>
              <div class="total">
                <span class="tip">共{{ provider.itemCount }}件，小计￥</span>
                <span class="amount">
                  {{ (provider.actualPrice - provider.expressFee) | price }}
                </span>
              </div>
            </div>
          </div>
        </div>

        <!-- 订单金额信息 -->
        <div class="total-fee panel">
          <div class="item-fee">
            <span class="label">商品金额</span>
            <span class="value">{{ (totalPrice + consultationFee) | price }}</span>
          </div>

          <div class="express-fee" v-if="deductAmount">
            <span class="label">优惠金额</span>
            <span class="value discount">{{ deductAmount | price }}</span>
          </div>

          <div class="express-fee">
            <span class="label">
              综合服务费
              <van-popover v-model="showPopover1" theme="dark" :offset="[-8, 8]" placement="top-start">
                <div style="width: 200px; padding: 8px 12px; line-height: 20px; font-size: 12px">
                  平台综合服务费是指为用户提供配送、打包、开票等服务产生的费用，按单收取。如有疑问，请您联系智云医道客服咨询。
                </div>
                <template #reference>
                  <van-icon name="cap-toastwarning" class="icon" @click="showPopover1 = true" />
                </template>
              </van-popover>
            </span>
            <span class="value">{{ expressFee | price }}</span>
          </div>

          <div class="instead-fry-fee" v-if="data.isSelectInsteadFrying != null && data.providerOrderList[0] && data.providerOrderList[0].orderClassifyType == '1'">
            <span class="label">
              代煎服务
            </span>
            <span class="value2">{{ data.isSelectInsteadFrying ? '是' : '否' }}</span>
          </div>
          <div class="instead-fry-fee" v-if="data.isSelectInsteadFrying && data.providerOrderList[0] && data.providerOrderList[0].orderClassifyType == '1' && insteadFryingFee != null">
            <span class="label">
              代煎服务费
            </span>
            <span class="value">{{ insteadFryingFee | price }}</span>
          </div>

          <div class="separator"></div>
          <div class="total">
            <span class="discount-tip" v-if="deductAmount">已优惠¥{{ deductAmount | price }}</span>
            <span class="tip">合计￥</span>
            <span class="amount">{{ actualPrice | price }}</span>
          </div>
        </div>
        <!-- 供应链二期-发票信息 -->
        <!-- <div v-if="data.needInvoice" class="order-info panel">
          <div class="title flex space-between">
            <span>发票信息</span>
            <div @click="handleInvoice(data.orderId, data.invoiceStatus)" style="font-size: 12px">
              <span style="color: #ff8200; line-height: 20px">
                {{ data.invoiceStatus == 'WAIT_TO_ISSUE' ? '待开具' : '已开具' }}
              </span>
              <van-icon style="color: #8c8c8c" name="cap-arrow" />
            </div>
          </div>
          <div class="line">
            <span class="label">发票抬头</span>
            <span class="value van-ellipsis">{{ data.invoiceTitle }}</span>
          </div>
          <div class="line">
            <span class="label">税号</span>
            <span class="value">{{ data.invoiceTaxNum }}</span>
          </div>
        </div> -->

        <!-- 发票信息 -->
        <div class="invoice panel" v-if="data.invoice">
          <div class="title flex space-between">
            <span>发票信息</span>
            <div @click="handleInvoice(data.orderId, data.invoiceStatus)" style="font-size: 12px">
              <span style="color: #ff8200; line-height: 20px">
                {{ data.invoiceStatus == 'ISSUED' ? '已开具' : '待开具' }}
              </span>
              <van-icon style="color: #8c8c8c" name="cap-arrow" />
            </div>
          </div>
          <!-- <div class="line">
            <span class="label">开票方式</span>
            <span class="value">{{ invoiceTypeZhMap[data.invoice.invoiceType] }}</span>
          </div>
          <div class="line">
            <span class="label">抬头类型</span>
            <span class="value">{{ invoiceWayZhMap[data.invoice.invoiceWay] }}</span>
          </div> -->
          <div class="line">
            <span class="label">发票抬头</span>
            <span class="value">{{ data.invoice.invoiceTitle }}</span>
          </div>
          <div class="line" v-if="data.invoice.invoiceType === 2">
            <span class="label">纳税人税号</span>
            <span class="value">{{ data.invoice.invoiceTaxNum }}</span>
          </div>
          <!-- <div class="line">
            <span class="label">邮箱或手机号</span>
            <span class="value">{{ data.invoice.invoiceReceive }}</span>
          </div> -->
        </div>
        <!-- 订单详情 -->
        <div class="order-info panel">
          <div class="title">订单信息</div>
          <div class="line">
            <span class="label">订单编号</span>
            <span class="value van-ellipsis" id="orderId">{{ data.orderId }}</span>
            <button class="btn-copy van-hairline--surround" ref="copy" :data-clipboard-text="data.orderId">复制</button>
          </div>
          <div class="line">
            <span class="label">下单时间</span>
            <span class="value">{{ data.createTime | parseDate }}</span>
          </div>
          <div class="line">
            <span class="label">支付方式</span>
            <span class="value">在线支付</span>
          </div>
          <div class="line" v-if="data.payTime">
            <span class="label">支付时间</span>
            <span class="value">{{ data.payTime | parseDate }}</span>
          </div>
          <div class="line adapt" v-if="data.remark">
            <span class="label">订单备注</span>
            <span class="value">
              {{ data.remark }}
            </span>
          </div>
        </div>
      </div>
    </div>
    <!-- 底部按钮 -->
    <div class="bottom van-hairline--top">
      <van-popover v-model="showPopover" placement="top-start" v-if="isShowMoreBtn && !canNotRefund">
        <template #reference>
          <span @click="showPopover = true" class="btn-more">更多</span>
        </template>
        <div class="popover-content">
          <button class="btn-popover" v-if="isUnpayed" @click="cancelOrder = true">取消订单</button>
          <button class="btn-popover" v-if="isUnshipped && !isInFatherOrder" @click="handleReturnGoods">
            申请退款
          </button>
        </div>
      </van-popover>
      <div class="btn-box">
        <van-button
          class="btn-text-color-59 btn-bottom"
          v-if="orderStatus == 12"
          color="#d9d9d9"
          size="small"
          plain
          hairline
          round
          @click="handleHint"
        >
          提醒发货
        </van-button>
        <van-button
          color="#d9d9d9"
          class="btn-text-color-59"
          plain
          round
          hairline
          size="small"
          v-if="expressOrderStatus.includes(orderStatus) && logisticsNum"
          @click="goLogistics"
        >
          查看物流
        </van-button>
        <van-button
          v-if="isShipped && canShowConfirmReceiving"
          size="small"
          type="primary"
          @click="confirmReceiving"
          data-track="zyjk-click-mzyjk-mall-ConfirmDeal"
          round
        >
          确认收货
        </van-button>

        <van-button
          class="btn-text-color-59 btn-bottom"
          v-if="!isUnpayed"
          color="#d9d9d9"
          size="small"
          plain
          hairline
          round
          @click="handleCustomerService"
        >
          联系客服
        </van-button>
        <van-button
          v-if="isUnpayed"
          class="btn-bottom btn-text-color-59"
          color="#d9d9d9"
          size="small"
          plain
          hairline
          round
          :disabled="isRequesting"
          @click="thirdPay"
        >
          他人代付
        </van-button>
        <van-button v-if="isUnpayed" :disabled="isRequesting" size="small" round type="primary" v-reClick="toPay">
          立即支付
        </van-button>
      </div>
    </div>
    <van-dialog
      v-model="cancelOrder"
      title="温馨提示"
      @confirm="confirmCancelOrder"
      @cancel="showPopover = false"
      show-cancel-button
    >
      <p class="cancel-order__description">您确定要取消这笔订单吗？</p>
    </van-dialog>
    <van-dialog v-model="showServiceModal" title="温馨提示" @confirm="callService" show-cancel-button>
      <p class="cancel-order__description">
        是否拨打客服热线？
        <br />
        (服务时间：周一至周六8:00-19:00)
      </p>
    </van-dialog>
  </div>
</template>

<script>
import utils from '@/util/index.js';
import { throttle } from 'lodash';
import { baseFormat } from '@zyf2e/utils';

import goodsItem from '@/components/goodsItem.vue';
import Clipboard from 'clipboard';
import Tag from './components/tag.vue';
import AuditFailTag from './components/auditFailTag.vue';

import {
  orderStatusEnum,
  codFlagEnum,
  RefundStateEnum,
  refundProductStateCnMap,
  invoiceTypeZhMap,
  invoiceWayZhMap
} from '@/constant';
import { Dialog } from '@zyf2e/capui-mobile';

import ZYPay from '@zyf2e/checkout-sdk';

import wechat from '@/util/wechatHelper.js';

const expressOrderStatus = [
  orderStatusEnum.shipped,
  orderStatusEnum.finished,
  orderStatusEnum.unrefund,
  orderStatusEnum.refunding,
  orderStatusEnum.refunded
];

const LOGISTICS_LIST = '/logistics-list';
const LOGISTICS = '/logistics';

export default {
  components: {
    goodsItem,
    AuditFailTag,
    Tag
  },
  filters: {
    baseFormat
  },
  data() {
    return {
      invoiceTypeZhMap,
      invoiceWayZhMap,
      showPopover: false,
      showPopover1: false,

      distanceMap: {},

      deliverTypeEnum: {
        EXPRESS: 1,
        PICKUPSELF: 2
      },

      codFlagEnum: codFlagEnum,
      expressOrderStatus: [
        orderStatusEnum.shipped,
        orderStatusEnum.finished,
        orderStatusEnum.unrefund,
        orderStatusEnum.refunding,
        orderStatusEnum.refunded
      ],

      canRestartAvisory: [orderStatusEnum.auditFail],

      showRejectReasonStatus: [
        orderStatusEnum.auditFail,
        orderStatusEnum.prescribeFail,
        orderStatusEnum.refunding,
        orderStatusEnum.refunded
      ],

      refundProductStateCnMap: refundProductStateCnMap,

      orderStatusEnum: orderStatusEnum,

      RefundStateEnum: RefundStateEnum,

      curTitleMap: {},

      invoiceKind: {
        1: '普通发票',
        2: '专用发票'
      },
      RefundStateCnMap: {
        [RefundStateEnum.FAIL]: '退款失败',
        [RefundStateEnum.SUCCESS]: '退款成功'
      },

      cancelOrder: false,

      showRx: false,

      couponId: null,

      rxImageUrl: '',

      remark: null,

      location: '',

      useCoin: false,

      drawInvoice: false,

      showServiceModal: false,

      showErrorPage: false,

      isShowCancelBtns: false,

      isRequesting: true,

      countDown: '',

      invoiceInput: {},

      orderPrescriptionInfo: {},

      data: {
        canAdvisory: false,
        currentTime: 0,
        closeTime: 0,
        payExpireTime: 0,
        receiverAddress: '',
        receiverName: '',
        receiverMobile: '',
        invoiceType: 0,
        invoiceTitle: '',
        invoiceTaxNum: '',
        memberLevel: 0,
        providerOrderList: [],
        rxImageUrl: '',
        paidWallet: 0
      },
      orderStatus: null,

      interval: 0,

      submitOrderParams: {},

      logisticsNum: 0,

      isFromZyyd: true,

      // 兼容v5.5之前的老数据
      isOldData: false,

      refundState: RefundStateEnum.FAIL,

      showMoreBtnStatus: [
        orderStatusEnum.unpayed,
        orderStatusEnum.unshipped,
        // orderStatusEnum.auditFail, // 订单驳回不显示更多
        orderStatusEnum.waitReturnGoods,
        orderStatusEnum.waitGetGoods
      ],

      isInFatherOrder: false,
      payLock: false
    };
  },

  computed: {
    subOrder() {
      const subOrderList = this.data.providerOrderList;
      if (Array.isArray(subOrderList) && subOrderList.length > 0) {
        return subOrderList[0];
      }
      return { orderPickUpInfo: { storeInfo: {} } };
    },
    receiverInfo() {
      return (this.data && this.data.receiverInfo) || {};
    },

    deliveryType() {
      const deliveryWay = this.subOrder.deliveryWay;
      const status = this.data.status;
      if (deliveryWay == this.deliverTypeEnum.EXPRESS) {
        return 'express';
      }
      if (deliveryWay == this.deliverTypeEnum.PICKUPSELF) {
        if (
          status == orderStatusEnum.unpayed ||
          status == orderStatusEnum.canceled ||
          status == orderStatusEnum.expired ||
          status == orderStatusEnum.unaudit ||
          status == orderStatusEnum.auditing
        ) {
          return 'pickupbyself-nopay';
        } else {
          return 'pickupbyself-payed';
        }
      }
      return 'none';
    },
    expressFee() {
      return this.data.expressFee || 0;
      // return this.data.providerOrderList
      //   ? this.data.providerOrderList.reduce((pre, cur) => pre + cur.expressFee, 0)
      //   : 0;
    },

    insteadFryingFee() {
      return this.data.insteadFryingFee;
    },

    deductAmount() {
      return this.data.deductAmount || 0;
    },

    totalPrice() {
      return this.data.totalPrice;
    },

    consultationFee() {
      return this.data.consultationFee || 0;
    },

    actualPrice() {
      return this.data.actualPrice;
    },
    isUnpayed() {
      return orderStatusEnum.unpayed === this.orderStatus;
    },

    isUnshipped() {
      return orderStatusEnum.unshipped === this.orderStatus || orderStatusEnum.waitGetGoods === this.orderStatus;
    },

    isFinished() {
      return orderStatusEnum.finished === this.orderStatus;
    },

    isShipped() {
      return orderStatusEnum.shipped === this.orderStatus;
    },

    isAuditFail() {
      return orderStatusEnum.auditFail === this.orderStatus;
    },

    paramsOrderId() {
      // url上传的 orderId, 有可能是自订单id 也可能是父订单id
      return this.$route.params.id;
    },

    allPrice() {
      let price = 0;
      this.data.providerOrderList.forEach((item) => {
        price += item.totalPrice - item.expressFee;
      });
      // price -= this.data.paidWallet || 0;
      return price;
    },

    isShowMoreBtn() {
      return this.showMoreBtnStatus.includes(this.orderStatus); // 2.订单处于能退货取消的状态
    },

    canNotRefund() {
      return this.isInFatherOrder && this.orderStatus !== orderStatusEnum.unpayed;
    },

    canChangeReceiverAddress() {
      const status = this.data.status;

      if (
        status == orderStatusEnum.unpayed ||
        status == orderStatusEnum.auditing ||
        status == orderStatusEnum.unshipped
      ) {
        return true;
      }

      return false;
    },

    canShowConfirmReceiving() {
      // 在智云医道项目里，父订单的情况下，不能展示确认收获
      if (this.isInFatherOrder) return false;
      // 其余情况仅凭状态是否为已发货即可
      return true;
    },

    openTime() {
      return this.subOrder.storeInfo && this.subOrder.storeInfo.openTime;
    },

    hasRefund() {
      const items = this.subOrder?.orderDetails;
      if (!Array.isArray(items)) {
        return false;
      }
      const item = items[0];
      if (item && (item.refundState || item.refundState === 0)) {
        return true;
      }
      return false;
    },

    showAuditFailRefund() {
      return this.orderStatus === orderStatusEnum.auditFail && this.data.mainRefundId;
    }
  },

  // created() {
  //   this.$nextTick(async () => {
  //     await this.fetchData();
  //   });
  // },

  beforeDestroy() {
    this.clearInterval();
  },

  async mounted() {
    this.fetchData();

    // eslint-disable-next-line no-undef
    Telescope.trackPage({ trackId: 'zyyd-page-OrderDetails' });
    this.initClipBoard();

    const { orderType } = this.data;
    const backParams = { orderId: this.paramsOrderId, prescription: orderType === 7 ? '1' : '2' };
    await ZYPay.init({
      ...util.ZYpayConfig,
      channel: this.$route.query.channel,
      failUrl: encodeURIComponent(`${window.location.origin}#/payment/fail${util.parseParam(backParams)}`),
      successUrl: encodeURIComponent(`${window.location.origin}#/payment/success${util.parseParam(backParams)}`)
    });
  },
  methods: {
    async fetchData() {
      const { id } = this.$route.params;
      if (!id) {
        return;
      }

      try {
        const timeStamp = new Date();

        this.isRequesting = true;

        this.data = await this.$fetch.getSupplyOrderDetail({
          orderId: String(id),
          timeStamp: timeStamp.valueOf().toString()
        });

        this.isRequesting = false;

        if (!this.data.orderFillPrescriptionInfoDTO) {
          this.isOldData = true;
          this.orderPrescriptionInfo = {};
        } else {
          this.isOldData = false;
          this.orderPrescriptionInfo = this.data.orderFillPrescriptionInfoDTO || {};
        }

        this.showErrorPage = false;
      } catch (error) {
        this.showErrorPage = true;
      }
      const orderStatus = this.data.status;

      // 因为目前后台只支持子订单退款，所以展示多订单情况下不能暴露退款口子
      this.isInFatherOrder = this.data.providerOrderList?.length > 1;

      this.orderStatus = orderStatus;

      if (orderStatus === orderStatusEnum.unpayed) {
        const { currentTime = 0 } = this.data;
        const diff = currentTime - Date.now();
        this.returnCountDown(diff);
        this.interval = setInterval(() => {
          this.returnCountDown(diff);
        }, 1000);
      }
      if (expressOrderStatus.includes(orderStatus) && this.subOrder.deliveryWay == this.deliverTypeEnum.EXPRESS) {
        // const { expressUrl } = this.data.providerOrderList[0];
        const { orderId = '' } = this.data;
        const res = await this.$fetch.getOrderExpressList({
          orderId
          // expressUrl,
        });
        const { packageNum = 0 } = res || {};
        this.logisticsNum = packageNum;
      }

      this.getDistance();
    },

    async getDistance() {
      // 获取距离
      try {
        const providerOrderList = this.data.providerOrderList.filter((val) => {
          // 需要过滤有自提单的
          return val.storeInfo && val.storeInfo.supplierId && val.deliveryWay === 2;
        });

        const supplerIds = providerOrderList.map((val) => (val.storeInfo && val.storeInfo.supplierId) || '') || [];
        if (supplerIds && supplerIds.length > 0) {
          const res = await wechat.getLocation();
          const { latitude = '', longitude = '' } = res || {};
          if (latitude && longitude) {
            const distances = await this.$fetch.queryStoreDistance({
              latitude,
              longitude,
              supplerIds
            });

            const distanceMapTemp = {};
            (distances || []).forEach((ele) => {
              distanceMapTemp[ele.supplierId] = ele.distance;
            });
            this.distanceMap = distanceMapTemp;
          } else {
            console.log('get wx location error', res);
          }
        }
      } catch (e) {
        console.log('getLocationError', e);
      }
    },

    goLogistics() {
      const { expressUrl = '' } = this.data.providerOrderList[0];
      const { orderId = '' } = this.data;

      let str;
      if (this.logisticsNum > 1) {
        str = `${LOGISTICS_LIST}/${orderId}?expressUrl=${expressUrl}&isFromZyyd=${this.isFromZyyd}`;
      } else {
        str = `${LOGISTICS}/${orderId}?expressUrl=${expressUrl}&isFromZyyd=${this.isFromZyyd}`;
      }
      this.$router.push(str);
    },

    async confirmCancelOrder() {
      const dispatchHandel = this.isAuditFail ? this.$fetch.endOrder : this.$fetch.postCancelOrder;
      this.isShowCancelBtns = false;
      await dispatchHandel({
        orderId: this.paramsOrderId
      });
      const haveOnline = this.data.providerOrderList.some((el) => Number(el.codFlag) === this.codFlagEnum.payOnline);
      this.$toast(this.isAuditFail && haveOnline ? '我们将在7个工作日内为您完成退款' : '取消订单成功');
      await this.fetchData();

      // setTimeout(() => {
      //   this.$router.push({
      //     name: 'orderList',
      //     params: {
      //       active: 0
      //     },
      //     query: {
      //       ...this.$route.query
      //     }
      //   });
      // }, 1500);
    },

    closeCannelOrder() {
      this.isShowCancelBtns = false;
    },

    callService() {
      window.location.href = `tel: 400-921-6690`;
    },

    async toPay() {
      if (this.payLock) {
        this.$toast('支付中，请勿重复点击');
        return;
      }
      this.payLock = true;
      try {
        const { tradeNo = '' } = await this.$fetch.fetchGetTradeNo({
          orderId: this.paramsOrderId
        });
        await ZYPay.prePay({ tradeNo });
        this.payLock = false;
      } catch (error) {
        this.payLock = false;
        if (error === 'INIT_ADAPT_ERROR') {
          Dialog.confirm({
            title: '温馨提示',
            message: '支付环境异常,请刷新重试',
            confirmButtonText: '立即重试'
          })
            .then(() => {
              window.location.reload();
              // on confirm
            })
            .catch((action) => {
              // on cancel or assist
            });
          return;
        }
        this.$toast(error && error.message ? error.message : error);
      }

      // const backParams = { orderId: this.orderId, prescription: orderType === 7 ? '1' : '2' };

      // utils.payHandle.call(this, {
      //   tradeNo,
      //   backParams,
      //   channel: this.$route.query.channel
      // });
    },

    onPayClick: throttle(function () {
      this.toPay();
    }, 700),

    returnCountDown(diff) {
      const { payExpireTime = 0 } = this.data;
      const now = Date.now();
      const spareTime = payExpireTime - (now + diff);
      if (spareTime > 0) {
        this.countDown = `请在  ${utils.toHHmmss(spareTime, 'en')}  内完成付款，超时将自动取消`;
      } else {
        this.clearInterval();
      }
    },

    clearInterval() {
      window.clearInterval(this.interval);
    },

    async confirmReceiving() {
      const { orderId = '' } = this.data;
      // eslint-disable-next-line no-undef
      Telescope.trackEvent({ trackId: 'zyyd-click-ConfirmDeal' });
      await this.$fetch.confirmSupplyOrder({ orderId });
      await this.fetchData();
    },

    async handleReturnGoods() {
      try {
        const { orderId = '', orderClassifyType = '1' } = this.data;
        const { canRefund, message = '该笔订单不能再发起退款了' } = await this.$fetch.checkOrderCanRefund({
          orderSn: orderId
        });
        if (canRefund) {
          this.$router.push({
            path: '/select-refund',
            query: {
              orderSn: orderId,
              expressFee: this.expressFee || 0,
              orderClassifyType
            }
          });
        } else {
          this.$toast(message);
        }
      } catch (e) {}
    },

    initClipBoard() {
      const clipboard = new Clipboard(this.$refs.copy);
      clipboard.on('success', (e) => {
        this.$toast('复制成功');
        e.clearSelection();
      });
    },
    navigate() {
      let { longitude, latitude, address, name } = this.subOrder.storeInfo;
      if (!longitude || !latitude) {
        this.$toast('缺少经纬度');
        return;
      }
      window.wx.openLocation({
        latitude: +latitude, // 纬度，浮点数，范围为90 ~ -90
        longitude: +longitude, // 经度，浮点数，范围为180 ~ -180。
        name, // 位置名
        address, // 地址详情说明
        scale: 20, // 地图缩放级别,整型值,范围从1~28。默认为最大
        infoUrl: '' // 在查看位置界面底部显示的超链接,可点击跳转
      });
    },
    thirdPay() {
      this.$router.push('/third-pay?orderId=' + this.paramsOrderId);
    },
    jumpToRefund(goods) {
      // 传的子订单
      const { orderId = '' } = this.data;
      if (goods.refundOrderNum > 1) {
        this.$router.push({
          path: '/refund-list',
          query: {
            orderDetailId: goods.orderDetailId,
            orderId: orderId
          }
        });
        return;
      }
      this.$router.push('/refund/' + goods.refundId);
    },
    goChangeAddress() {
      const { addressId = '' } = this.receiverInfo;
      const { status = null } = this.data;
      this.$router.push({
        path: '/address-list',
        query: {
          orderId: this.paramsOrderId,
          addressId,
          status
        }
      });
    },
    // 查看发票详情
    handleInvoice(id = 1, status = 'WAIT_TO_ISSUE') {
      this.$router.push({
        name: 'invoiceDetail',
        params: {
          id: id
        },
        query: {
          status
        }
      });
    },
    handleCustomerService() {
      location.href = 'https://work.weixin.qq.com/kfid/kfc0bcb7bc8ba978d2a';
    },
    async handleHint() {
      // const now = Date.now();
      // const payTime = this.data.payTime || now;
      // const interval = now - payTime;
      // if (interval <= 1000 * 3600 * 48) {
      //   Dialog.alert({
      //     title: '提醒成功',
      //     message: '商品预计会在下单后48小时内发货，请耐心等待',
      //     confirmButtonText: '好的'
      //   })
      // } else {
        const res = await this.$fetch.urgeOrder({ orderId: this.data.orderId });
        Dialog.alert({
          title: '提醒成功',
          message: res || '已催促商家尽快安排发货',
          confirmButtonText: '好的'
        })
      // }
    }
  }
};
</script>

<style lang="less" scoped>
.page-order-detail {
  height: 100%;
  display: flex;
  flex-direction: column;
  .btn-text-color-59 {
    &.size-12 {
      font-size: 12px;
    }
    /deep/ .van-button__content {
      color: #595959;
    }
  }
  .audit-fail-container {
    display: inline-flex;
    align-items: center;
  }
  .panel {
    background: #fff;
    padding: 16px 12px;
    border-radius: 8px;
  }
  .separator {
    height: 1px;
    width: 100%;
    background: #eeeeee;
    transform: scaleY(0.5);
  }
  .title {
    font-size: 16px;
    font-weight: 500;
    color: #262626;
    margin: 8px 0;
  }
  .line {
    height: 40px;
    display: flex;
    align-items: center;
    .label {
      width: 88px;
      font-size: 14px;
      color: #8c8c8c;
      flex: 0 0 auto;
    }
    .value {
      font-size: 14px;
      line-height: 21px;
      color: #262626;
      flex: 1 1 auto;
    }
    .btn-copy {
      position: relative;
      width: 56px;
      height: 24px;
      background: #ffffff;
      border-radius: 12px;
      border: 1px solid #d9d9d9;
      font-size: 12px;
      font-weight: 400;
      color: #595959;
      flex: 0 0 auto;
      border: none;
      margin-left: 12px;
      &.van-hairline--surround::after {
        border-radius: 24px;
      }
    }
    &.adapt {
      height: auto;
      align-items: flex-start;
      padding: 10px 0;
      .label {
        margin-top: 3px;
      }
    }
  }
  .total {
    width: 100%;
    height: 48px;
    text-align: right;
    line-height: 48px;
    .tip {
      font-size: 12px;
      font-weight: 400;
      color: #262626;
      line-height: 16px;
    }
    .amount {
      font-size: 16px;
      font-weight: 500;
      color: #262626;
      line-height: 16px;
    }
    .discount-tip {
      font-size: 12px;
      color: #262626;
      margin-right: 10px;
    }
  }
  .content {
    position: relative;
    padding-top: 28px;
    flex: 1 1 auto;
    height: 400px;
    overflow: auto;
    .header {
      position: absolute;
      z-index: 1;
      top: -28px;
      width: 100%;
      height: 235px;
      background: linear-gradient(180deg, #1e8dff 0%, #1e8dff 50%, rgba(30, 141, 255, 0) 100%);
      // background: linear-gradient(180deg, #1e8dff 0%, rgba(30, 141, 255, 0) 100%);
    }
    .container {
      position: relative;
      z-index: 2;
    }
    .order-status {
      .status {
        font-size: 20px;
        font-weight: bold;
        color: #ffffff;
        margin: 0 0 8px 24px;
      }
      .status-description {
        display: block;
        font-size: 14px;
        color: #ffffff;
        line-height: 14px;
        margin: 0 0 20px 24px;
      }
    }
    .customer-info-express {
      display: flex;
      align-items: center;
      margin: 0 12px;
      .address {
        font-size: 16px;
        font-weight: 500;
        color: #262626;
        line-height: 24px;
        margin-bottom: 8px;
        display: block;
      }
      .patient-info {
        font-size: 14px;
        font-weight: 400;
        color: #8c8c8c;
        line-height: 14px;
      }
    }
    .customer-info-pickupbyself-payed {
      margin: 0 12px;
      padding-bottom: 12px;
      .shop-name {
        display: block;
        font-size: 14px;
        font-weight: 400;
        color: #262626;
        margin-bottom: 8px;
        line-height: 21px;
      }
      .shop-time {
        font-size: 12px;
        font-weight: 400;
        color: #8c8c8c;
        display: block;
        margin-bottom: 20px;
      }
      .write-off-code {
        text-align: center;
        margin: 40px 0 32px;
        .code {
          display: block;
          font-size: 32px;
          font-weight: 500;
          color: #1e8dff;
          line-height: 32px;
          margin-bottom: 8px;
        }
        .tip {
          display: block;
          font-size: 12px;
          font-weight: 400;
          color: #8c8c8c;
        }
      }
      .shop-address {
        display: flex;
        align-items: flex-start;
        justify-content: flex-start;
        padding: 8px 0;
        .label {
          width: 80px;
          font-size: 14px;
          font-weight: 400;
          color: #8c8c8c;
          flex: 0 0 auto;
          line-height: 20px;
        }
        .address-text {
          flex: 1 1 auto;
          font-size: 14px;
          font-weight: 500;
          color: #262626;
          line-height: 21px;
          word-break: break-all;
        }
        .btn-navigate {
          flex: 0 0 auto;
          width: 56px;
          height: 24px;
          background: #ffffff;
          border-radius: 12px;
          // border: 1px solid #d9d9d9;
          font-size: 12px;
          font-weight: 400;
          color: #595959;
          line-height: 24px;
          margin-left: 12px;
          margin-top: -2px;
        }
      }
      .line {
        height: 36px;
        .label {
          width: 80px;
        }
        .bold-text {
          font-weight: 500;
        }
      }
    }
    .customer-info-pickupbyself-nopay {
      display: flex;
      margin: 0 12px;
      .name,
      .mobile {
        width: 50%;
        flex: 0 0 auto;
      }
      .label {
        display: block;
        font-size: 12px;
        color: #595959;
        margin-bottom: 14px;
      }
      .value {
        display: block;
        font-size: 16px;
        font-weight: 500;
        color: #262626;
      }
    }
    .provider-list {
      .provider-item {
        margin: 12px;
        padding-bottom: 0;
        .provider-header {
          .first-line {
            display: flex;
            align-items: center;
            position: relative;
            justify-content: space-between;
            width: 100%;
            .provider-info {
              flex: 1;
              display: inline-flex;
              align-items: center;
            }
            .provider-tip {
              margin-left: 12px;
            }
            .provider-logo {
              width: 20px;
              height: 20px;
              border-radius: 2px;
              margin-right: 8px;
            }
            .provider-name {
              font-size: 14px;
              line-height: 16px;
              font-weight: 400;
              color: #262626;
            }
            .tag-in-order {
              margin-left: 4px;
            }
            .provider-distance {
              // position: absolute;
              // right: 0;
              font-size: 12px;
              font-weight: 400;
              color: #8c8c8c;
              line-height: 20px;
            }
            .btn-refund-detail {
              // position: absolute;
              // right: 0;
              width: 80px;
              height: 24px;
              border-radius: 12px;
              // border: 1px solid #d9d9d9;
              font-size: 12px;
              font-weight: 400;
              color: #595959;
              background: #fff;
            }
          }
          .second-line {
            font-size: 12px;
            font-weight: 400;
            color: #8c8c8c;
            margin-top: 7px;
          }
        }
        .separator {
          margin-top: 16px;
        }
        .hint {
          padding: 8px 12px;
          background: #FFF7E6;
          font-size: 12px;
          font-weight: 400;
          color: #FF8200;
          line-height: 16px;
        }
        .provider-footer {
          .express {
            display: flex;
            justify-content: space-between;
            align-items: center;
            height: 48px;
            .label {
              font-size: 14px;
              font-weight: 400;
              color: #262626;
            }
            .value {
              font-size: 12px;
              font-weight: 400;
              color: #1e8dff;
            }
          }
        }
      }
    }
    .total-fee {
      padding: 7px 12px 0px;
      margin: 12px;
      .item-fee,
      .express-fee,
      .instead-fry-fee {
        width: 100%;
        height: 36px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .label {
          font-size: 14px;
          font-weight: 400;
          color: #262626;
        }
        .value {
          font-size: 14px;
          font-weight: 400;
          color: #262626;
          line-height: 14px;
          &::before {
            content: '￥';
            font-size: 10px;
          }
          &.discount {
            color: #ff4e47;
            &::before {
              content: '-￥';
              color: #ff4e47;
              font-size: 14px;
            }
          }
        }
        .value2 {
          font-size: 14px;
          font-weight: 400;
          color: #262626;
          line-height: 14px;
        }
      }
      .separator {
        margin-top: 13px;
      }
    }
    .invoice {
      padding: 12px;
      margin: 12px;
    }
    .order-info {
      padding: 12px;
      margin: 12px;
    }
  }
  .bottom {
    width: 100%;
    height: 56px;
    background: #ffffff;
    display: flex;
    align-items: center;
    // justify-content: space-between;
    padding: 0 12px;
    flex: 0 0 auto;
    position: relative;
    .btn-more {
      font-size: 14px;
      font-weight: 400;
      color: #8c8c8c;
      padding: 0;
    }
    .btn-box {
      position: absolute;
      right: 16px;
    }
    .btn-bottom {
      font-size: 14px;
      font-weight: 400;
      color: #595959;
      background: #fff;
      margin-left: 8px;
    }
    .van-button {
      margin-left: 8px;
    }
  }
}
.popover-content {
  .btn-popover {
    display: block;
    height: 40px;
    width: 96px;
    font-size: 14px;
    font-weight: 400;
    color: #595959;
    background: #fff;
    border: none;
  }
}
.cancel-order__description {
  text-align: center;
  color: #999;
  padding: 12px 28px;
  font-size: @font-size-sm;
}
</style>
